import React, {useState, useEffect, useContext} from "react";
import {Grid, Col} from "../../../../styles/Grid";
import styled from "styled-components";
import {SelectStyled} from "../../../../styles/Forms";
import PrintTypeData from "./PrintTypeData";
import TypeSelects from "./TypeSelects";
import {HomeContext} from "../../../../context/HomeProvider";

export default function ElementoItem({data, editable}) {
   const {updateBlock} = useContext(HomeContext);
   const [currentType, setType] = useState();
   const [currentId, setId] = useState();

   useEffect(() => {
      let {idReference, type} = data;
      setType(type); 
      setId(idReference);
   }, [data]);

   const detectChange = e => { 
      updateBlock(data.idHomeBlock, e.target.value, e.target.name);
   };

   return (
      <Grid className="elementBlock">
         {!editable ? (
            <>
               <PrintTypeData type={data.type} data={data.data[0]} />
            </>
         ) : (
            <Col large={12} className="element">
               <Grid>
                  <Col large={10}>
                     <ReadEl className="ReadEl">
                        <SelectStyled
                           name="type"
                           defaultValue={currentType}
                           onChange={e => {
                              setType(e.target.value);
                              detectChange(e);
                           }}
                        >
                           <option value={0} disabled>
                              Selecciona un tipo de elemento
                           </option>
                           <option value="Facilitators">
                              Facilitador
                           </option>
                           <option value="Courses" >
                              Cursos
                           </option>
                           <option value="DomeqAcademy">
                              Domecq Academy
                           </option>
                           <option value="Testimonials">
                              Mi experiencia en Domecq Academy
                           </option>
                        </SelectStyled>
                     </ReadEl> 
                     <ReadEl>
                        <TypeSelects change={detectChange} type={currentType} data={data.data ? data.data[0] : {}} current={currentId} />
                     </ReadEl>
                  </Col>
               </Grid>
            </Col>
         )}
      </Grid>
   );
}

/* const AvailableTypes = [
   {value: "Facilitators", label: "Facilitador"},
   {value: "Courses", label: "Cursos"},
   {value: "DomeqAcademy", label: "Domecq Academy"},
   {value: "Testimonials", label: "Testimonios"},
]; */

const ReadEl = styled.div`
   box-sizing: border-box;
   margin-right: 1em;
   backround: red;

   p,
   select {
      font-weight: 300;
      font-size: 0.9em;
      margin: 0;
      background-color: transparent;
   }
   select {
      margin-bottom: 1 em;
   }
   p {
      margin: 0.5em;
   }
`;
